import React, { useEffect, useState, useRef } from 'react';
import { observer } from 'mobx-react';
import './style.scss';
import { useStore } from '../../../stores';
import ViewClientPage from './ViewClient';
import { TextInput, OutlinedButton, PaginationControls,ItemsCountDisplay , SearchBar} from '../../../components';
import {  formatCash, formatDate } from '../../../utils/sharedFunctions';
import { useServerFilterUsers } from '../../../hooks/useUserFilter';
const Credipple = `${process.env.REACT_APP_CDN_URL}/globalAssets/CredippleLogo.svg`;
const AddIcon = `${process.env.REACT_APP_CDN_URL}/globalAssets/AddIcon.svg`;
const AtoZ = `${process.env.REACT_APP_CDN_URL}/globalAssets/A-ZFilter.svg`;
const ZtoA = `${process.env.REACT_APP_CDN_URL}/globalAssets/Z-AFilter.svg`;
const SearchIcon = `${process.env.REACT_APP_CDN_URL}/globalAssets/SearchIcon.svg`;
var mobile = require('is-mobile');

const Clients = observer(() => {
    const { userStore, uiStore } = useStore();
    const [IsMenuOpen, setIsMenuOpen] = useState(false);
    const [AddNewClient, setAddNewClient] = useState(false);
    const [ViewClient, setViewClient] = useState(false);
    const [Clients, setClients] = useState([]);
    const [Leads, setLeads] = useState([]);
    const [AllUsers, setAllUsers] = useState([]);
    const [SelectedClientID, setSelectedClientID] = useState('');
    const [TotalJobs, setTotalJobs] = useState('A-Z');
    const [SelectedClient, setSelectedClient] = useState({});
    const [NameFilter, setNameFilter] = useState('A-Z');
    const [ClientNoFilter, setClientNoFilter] = useState('A-Z');
    const [Payments, setPayments] = useState('A-Z');
    const [CompName, setCompName] = useState('A-Z');
    const [DateCreated, setDateCreated] = useState('A-Z');
    const [searchTerm, setSearchTerm] = useState('');
    const [TypeSelected, setTypeSelected] = useState('Personal');
    const EmailRegex = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
    const [IsEdited, setIsEdited] = useState(false);
    const [Professionals, setProfessionals] = useState([]);
    const isFirstRender = useRef(true);
    const [Pagination, setPagination] = useState({ 
        currentPage :  1, 
        hasMore     : false, 
        nextCursor  : "", 
        prevCursor  : "",
        pageSize    : 8, 
        totalPages  : 0, 
        totalUsers  : 0
    })
    const [NewClientInfo, setNewClientInfo] = useState({
        authenticators: [], accountType: "", bio: "", briefs: [], businessType: null, city: "",
        companyName: null, companyRegistrationNumber: null, companyVatNumber: null, companyWebsite: null,
        country: "", createdAt: "", date: new Date(), email: "", firstName: "", fullName: "", imgUrl: "",
        lastName: "", notifications: [], permissions: [], phone: "", professional: { worksuite: {}, worksuiteId: null, gender: "", languages: "", race: "" },
        projects: [], role: "", roles: [], state: ""
    });
    const {serverFilterUsers} = useServerFilterUsers({userStore, uiStore, setUsers:setClients, setPagination, searchTerm , i:'', type:'CLIENT'}) 
    useEffect(() => {
        getClients(null, 'CLIENT', '', searchTerm);
    }, [IsEdited]);
    useEffect(()=>{
        if (isFirstRender.current) {
            isFirstRender.current = false; 
            return; 
        }else{
            if (searchTerm !== "") {
                //( searchStr, lastId, navId, type)
                serverFilterUsers(searchTerm, "", "", "CLIENT");
            }else{
                getClients("", "CLIENT", "");
            };
        };
    }, [searchTerm]);
    const getClients = async (lastId, type, navId, searchTerm) => {
        try {
            uiStore.setLoading(true);
            const Users = await userStore.getUsers(lastId, type, navId, searchTerm);
            setClients(Array.isArray(Users.users) ? Users.users : []);
            setPagination (Users.pagination)
        } catch (error) {
            uiStore.showNotification('Failed to fetch clients.', 'error');
        } finally {
            uiStore.setLoading(false);
        }
    };
    const handleAddClient = () => {
        setAddNewClient(true);
        setIsMenuOpen(false);
    };
    const handleViewClient = (clientId, client) => {
        if (!client) {
            uiStore.showNotification('Client not found', 'error');
            return;
        }
        setSelectedClientID(clientId);
        setSelectedClient(client);
        setViewClient(true);
    };
    const handleClientInfoChange = (e) => {
        let client = { ...NewClientInfo };
        client.type = TypeSelected.toLowerCase();
        client.accountType = TypeSelected.toLowerCase();
        client.role = 'Client';
        client.roles = [1989];

        switch (e.currentTarget.id) {
            case 'Name':
                const fullName = e.target.value.split(' ');
                client.firstName = fullName[0] || '';
                client.lastName = fullName[1] || '';
                client.fullName = `${client.firstName} ${client.lastName}`;
                break;
            case 'ClientNum': 
                client.ClientNumber = e.target.value; 
                break;
            case 'Email': 
                client.email = e.target.value; 
                break;
            case 'Organisation': 
                client.organisation = e.target.value; 
                break;
            case 'ContactNum': 
                client.phone = e.target.value; 
                break;
            case 'Address': 
                client.address = e.target.value; 
                break;
            case 'CompName': 
                client.companyName = e.target.value; 
                break;
            case 'RegistrationNum': 
                client.registrationNumber = e.target.value; 
                break;
            case 'TaxIdentification': 
                client.taxIdentification = e.target.value; 
                break;
            case 'Website': 
                client.website = e.target.value; 
                break;
            case 'Industry': 
                client.industry = e.target.value; 
                break;
            default:
                uiStore.showNotification(`Unhandled input id: "${e.currentTarget.id}"`, 'warning');
                break;
        }

        setNewClientInfo(client);
    };
    const closeAddNewClient = () => setAddNewClient(false);
    const saveNewClient = async () => {
        try {
            uiStore.setLoading(true);
            const client = NewClientInfo;

            if (client.type === 'Personal' && !EmailRegex.test(client.email)) {
                uiStore.showNotification('Please enter a valid email address.', 'error');
                return;
            }

            if (TypeSelected === 'Company') {
                if (!client.companyName || !client.registrationNumber || !client.taxIdentification) {
                    uiStore.showNotification('Please fill in all required company fields.', 'error');
                    return;
                }
            } else {
                const requiredFields = ['firstName', 'lastName', 'email', 'phone'];
                for (let field of requiredFields) {
                    if (!client[field]) {
                        uiStore.showNotification(`Please fill in the ${field} field.`, 'error');
                        return;
                    }
                }
            }

            const addClient = await userStore.createUser(client);
            if (!addClient) {
                uiStore.showNotification('Failed to add client.', 'error');
                return;
            }

            addClient.fullName = `${addClient.firstName || ''} ${addClient.lastName || ''}`;
            clearClientUseState();
            getClients(null, 'CLIENT', '', searchTerm);
            setAddNewClient(false);
            setViewClient(false);
        } catch (e) {
            console.error(e);
            uiStore.showNotification('An error occurred while saving the client.', 'error');
        } finally {
            uiStore.setLoading(false);
        }
    };
    const backClicked = (back, isEdited) => {
        if (isEdited) setIsEdited(isEdited);
        setViewClient(back);
        getClients(null, 'CLIENT', '', searchTerm);
        
    };
    const handleTitleFilterComps = (e) => {
        const clientsCopy = [...Clients];
        const id = e.target.id;

        switch (id) {
            case 'ClientName':
                setNameFilter(prev => {
                    const sorted = prev === 'Z-A'
                        ? clientsCopy.sort((a, b) => (a.firstName || '').toLowerCase().localeCompare((b.firstName || '').toLowerCase()))
                        : clientsCopy.sort((a, b) => (b.firstName || '').toLowerCase().localeCompare((a.firstName || '').toLowerCase()));
                    setClients(sorted);
                    return prev === 'Z-A' ? 'A-Z' : 'Z-A';
                });
                break;
            case 'compName':
                setCompName(prev => {
                    const sorted = prev === 'Z-A'
                        ? clientsCopy.sort((a, b) => (a.companyName || '').toLowerCase().localeCompare((b.companyName || '').toLowerCase()))
                        : clientsCopy.sort((a, b) => (b.companyName || '').toLowerCase().localeCompare((a.companyName || '').toLowerCase()));
                    setClients(sorted);
                    return prev === 'Z-A' ? 'A-Z' : 'Z-A';
                });
                break;
            case 'ClientNo':
                setClientNoFilter(prev => {
                    const sorted = prev === 'Z-A'
                        ? clientsCopy.sort((a, b) => String(a._id || '').localeCompare(String(b._id || '')))
                        : clientsCopy.sort((a, b) => String(b._id || '').localeCompare(String(a._id || '')));
                    setClients(sorted);
                    return prev === 'Z-A' ? 'A-Z' : 'Z-A';
                });
                break;
            case 'TotalJobs':
                setTotalJobs(prev => {
                    const sorted = prev === 'Z-A'
                        ? clientsCopy.sort((a, b) => (a.briefs?.length || 0) + (a.projects?.length || 0) - ((b.briefs?.length || 0) + (b.projects?.length || 0)))
                        : clientsCopy.sort((a, b) => (b.briefs?.length || 0) + (b.projects?.length || 0) - ((a.briefs?.length || 0) + (a.projects?.length || 0)));
                    setClients(sorted);
                    return prev === 'Z-A' ? 'A-Z' : 'Z-A';
                });
                break;
            case 'payment':
                setPayments(prev => {
                    const sorted = prev === 'Z-A'
                        ? clientsCopy.sort((a, b) => (a.totalPayments || 0) - (b.totalPayments || 0))
                        : clientsCopy.sort((a, b) => (b.totalPayments || 0) - (a.totalPayments || 0));
                    setClients(sorted);
                    return prev === 'Z-A' ? 'A-Z' : 'Z-A';
                });
                break;
            case 'date':
                setDateCreated(prev => {
                    const sorted = prev === 'Z-A'
                        ? clientsCopy.sort((a, b) => new Date(a.createdAt || 0) - new Date(b.createdAt || 0))
                        : clientsCopy.sort((a, b) => new Date(b.createdAt || 0) - new Date(a.createdAt || 0));
                    setClients(sorted);
                    return prev === 'Z-A' ? 'A-Z' : 'Z-A';
                });
                break;
            default:
                console.warn(`Unhandled sort case: ${id}`);
                break;
        }
    };
    const handleSearchChange = (value) => {setSearchTerm(value)};
    const handleTabChange = (e) => {
        clearClientUseState();
        setTypeSelected(e.currentTarget.id);
    };
    function clearClientUseState() {
        setNewClientInfo({
            authenticators: [], accountType: "", bio: "", briefs: [], businessType: null, city: "",
            companyName: "", companyRegistrationNumber: null, companyVatNumber: null, companyWebsite: null,
            country: "", createdAt: "", date: new Date(), email: "", firstName: "", fullName: "", imgUrl: "",
            lastName: "", notifications: [], permissions: [], phone: "", professional: { worksuite: {}, worksuiteId: null, gender: "", languages: "", race: "" },
            projects: [], role: "", roles: [], state: "", type: "", industry: ""
        });
    }
    const handlePageChange = (e) => {
        const ID  = e;

        if (ID === 'next' && Pagination.hasMore) {
            getClients(Pagination.nextCursor, 'CLIENT', 'lastId', searchTerm);
        }else{
            if (Pagination.currentPage > 1) {
                getClients(Pagination.prevCursor, 'CLIENT', 'prevId', searchTerm);
            }
        }
    };

    if (mobile()) {
        return (
            <div>

            </div>
        );

    } else {
        return (
            <div className='clientsPage'>
                <div className='clientsPageHeader'>
                    <p>Clients</p>
                    <img src={Credipple} alt='Credipple Logo' />
                </div>

                <div className='clientsPageBody'>
                    {(ViewClient) ?

                        <ViewClientPage allUsers={AllUsers} backClick={(e, isEdited) => { backClicked(e, isEdited) }} leads={Leads} pros={Professionals} selectedPro={SelectedClient} />

                        :

                        <div className='clientList'>
                            {/* HEADER SECTION */}
                          
                            <div className='clientListHeader'>
                                <div className='clientListSection'>
                                    <p>Client List</p>
                                        {(IsMenuOpen) ?
                                            <div className='clientMenuOpen'>
                                                <div className='AddClientConatiner'>
                                                    <img src={AddIcon} alt='Add Client' onClick={handleAddClient} />
                                                    <p onClick={handleAddClient}>Add Client</p>
                                                </div>
                                                <hr />
                                            </div> : null
                                        }
                                </div>
                               
                                <ItemsCountDisplay
                                    currentPage={Pagination.currentPage}
                                    totalPages={Pagination.totalPages}
                                    totalUsers={Pagination.totalUsers}
                                    pageSize={8} // optional, default is 8
                                />
                                <div className='search-bar-section' style={{ width: '25%', height: '60%' }}>
                                    {/* <img src={SearchIcon} alt='Search Icon' /> */}
                                    <SearchBar
                                        onSearch={(e)=>handleSearchChange(e)}
                                        placeholder='Search'
                                        debounceDelay={1000}
                                        disabled={false}
                                        className=''
                                        searchIconUrl={SearchIcon}
                                        style={{ width: '100%' }}
                                    />
                                    {/* <input style={{ color: '#6D4194' }} placeholder='Search' onChange={handleSearchChange} value={searchTerm}></input> */}
                                </div>

                            </div>

                            <div className='clientListContent' >
                                <div className='clientContentCover'>
                                    <div className='clientListLabels'>
                                        <div className='ClientNameSect'>
                                            <p onClick={handleTitleFilterComps} id='ClientName'>Client Name</p>
                                            <img src={NameFilter === 'A-Z' ? AtoZ : ZtoA} style={{ cursor: 'pointer' }} id='ClientName' onClick={handleTitleFilterComps} />
                                        </div>
                                        <div className='ClientNameSect'>
                                            <p onClick={handleTitleFilterComps} id='ClientNo'>Contact Number</p>
                                            {/* <img src={ClientNoFilter === 'A-Z' ? AtoZ : ZtoA} style={{ cursor: 'pointer' }} id='ClientNo' onClick={handleTitleFilterComps} /> */}
                                        </div>
                                        <div className='ClientNameSect' style={{ minWidth: '10dvw' }}>
                                            <p>Client Details</p>
                                        </div>
                                        <div className='ClientNameSect'>
                                            <p onClick={handleTitleFilterComps} id='compName'>Company Name</p>
                                            <img src={CompName === 'A-Z' ? AtoZ : ZtoA} style={{ cursor: 'pointer' }} id='compName' onClick={handleTitleFilterComps} />
                                        </div>
                                        <div className='ClientNameSect' style={{ minWidth: '10dvw' }}>
                                            <p onClick={handleTitleFilterComps} id='TotalJobs'>Total Jobs</p>
                                            <img src={TotalJobs === 'A-Z' ? AtoZ : ZtoA} style={{ cursor: 'pointer' }} id='TotalJobs' onClick={handleTitleFilterComps} />
                                        </div>
                                        <div className='ClientNameSect'>
                                            <p onClick={handleTitleFilterComps} id='payment'>Total Client Payments</p>
                                            <img src={Payments === 'A-Z' ? AtoZ : ZtoA} style={{ cursor: 'pointer' }} id='payment' onClick={handleTitleFilterComps} />
                                        </div>
                                        <div className='ClientNameSect'>
                                            <p onClick={handleTitleFilterComps} id='date'>Date Created</p>
                                            <img src={DateCreated === 'A-Z' ? AtoZ : ZtoA} style={{ cursor: 'pointer' }} id='date' onClick={handleTitleFilterComps} />
                                        </div>

                                    </div>
                                    <div className='availableClientSection'>
                                        {( Array.isArray(Clients) && Clients.length > 0 ? Clients?.map((item, index) => {
                                            return (
                                                <div className='clientCard' key={index}>
                                                    <p className='clientName'> {`${item.firstName || ''} ${item.lastName || ''}`}</p>
                                                    <p className='clientName'>{item?.phone ? item.phone : ''}</p>
                                                    <p className='clientName viewClient-Container' style={{ minWidth: '10dvw', }} onClick={() => handleViewClient(item._id, item)}>View</p>
                                                    <p className='clientName'> {`${item.companyName ?? ''}`}</p>
                                                    <p className='clientName' style={{ minWidth: '10dvw' }}>{item?.briefCount ?? 0}</p>
                                                    <p className='clientName'>{`ZAR ${formatCash(item.totalPayments || 0)}`}</p>
                                                    <p className='clientName' style={{ minWidth: '12dvw' }}>{formatDate(item.createdAt)}</p>
                                                </div>
                                            );
                                            }) : null
                                        )}
                                    </div>
                                </div>
                            </div>

                            <PaginationControls
                                currentPage={Pagination.currentPage}
                                totalPages={Pagination.totalPages}
                                onPageChange={(id)=>{handlePageChange(id)}}
                            />
                        </div>
                    }
                </div>

                {/* ADD CLIENT REGION */}
                {(AddNewClient) ?
                    <div className='addClientPopUp'>
                        <div className='clientHeaderSect'>
                            <p>Create Client</p>
                        </div>
                        <div className='viewBriefTypeSect'>
                            <div className={(TypeSelected === 'Personal' ? 'selectedType' : 'typeCard')} id='Personal' onClick={handleTabChange}>
                                <p>Personal</p>
                            </div>
                            <div style={{ marginLeft: '1.5%' }} className={(TypeSelected === 'Company' ? 'selectedType' : 'typeCard')} id='Company' onClick={handleTabChange}>
                                <p>Company</p>
                            </div>
                        </div>
                        {(TypeSelected === 'Company') ?
                            <div className='clientInputFields'>
                                <div className='textInputrContainer'>
                                    <TextInput className='textInputsStyle' value={NewClientInfo.companyName} label='Company Name' placeholder='Company Name' id='CompName' onChange={handleClientInfoChange}></TextInput>
                                    <TextInput className='textInputsStyle' value={NewClientInfo.companyRegistrationNumber} label='Company Registration' placeholder='Company Registration' id='RegistrationNum' onChange={handleClientInfoChange}></TextInput>
                                </div>
                                <div className='textInputrContainer'>
                                    <TextInput className='textInputsStyle' value={NewClientInfo.taxIdentification} label='Tax Identification' placeholder='Tax Identification' id='TaxIdentification' onChange={handleClientInfoChange}></TextInput>
                                    <TextInput className='textInputsStyle' value={NewClientInfo.companyWebsite} label='Website' placeholder='Website' id='Website' onChange={handleClientInfoChange}></TextInput>
                                </div>
                                <div className='textInputrContainer' style={{ justifyContent: 'flex-start', marginLeft: '5%' }}>
                                    <TextInput className='textInputsStyle' value={NewClientInfo.industry} label='Industry' placeholder='Industry' id='Industry' onChange={handleClientInfoChange}></TextInput>
                                </div>
                            </div>
                            : <div className='clientInputFields'>
                                <div className='textInputrContainer'>
                                    <TextInput className='textInputsStyle' label='Name & Surname' placeholder='Name & Surname' id='Name' onChange={handleClientInfoChange}></TextInput>
                                    <TextInput className='textInputsStyle' value={NewClientInfo.email} label='Email' placeholder='Email' id='Email' onChange={handleClientInfoChange}></TextInput>
                                </div>
                                <div className='textInputrContainer'>
                                    <TextInput className='textInputsStyle' value={NewClientInfo.phone} label='Contact No.' placeholder='Contact No.' id='ContactNum' onChange={handleClientInfoChange}></TextInput>
                                    <TextInput className='textInputsStyle' value={NewClientInfo.address} label='Address' placeholder='Address' id='Address' onChange={handleClientInfoChange}></TextInput>
                                </div>
                            </div>
                        }

                        <div className='actionSection'>
                            <OutlinedButton className='cancelButton' onClick={closeAddNewClient}>Cancel</OutlinedButton>
                            <OutlinedButton className='saveButton' onClick={saveNewClient}>Save</OutlinedButton>
                        </div>
                    </div> : null
                }
            </div>
        )
    }
})

export default Clients;